export enum RateTypes {
    Holiday = 'holiday',
    OnCall = 'onCall',
    Callback = 'callBack',
    Charge = 'charge'
}
